import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Popover: ComponentStyleConfig = {
  parts: ['PopoverContent', 'PopoverHeader', 'PopoverFooter'],
  baseStyle: (props: StyleFunctionProps) => ({
    PopoverContent: {
      boxShadow: 'lg',
      border: 0,
      _focus: { boxShadow: 'unset' },
    },
    PopoverHeader: {
      borderColor: mode('gray.200', 'gray.700')(props),
    },
    PopoverFooter: {
      borderColor: mode('gray.200', 'gray.700')(props),
      display: 'flex',
      justifyContent: 'flex-end',
    },
  }),
};

export default Popover;
